import React from 'react';

import './Title.scss';

type TitleProps = {
  name: string;
  textPosition?: '' | 'auth-title--center'
}

export function Title(props: TitleProps): React.JSX.Element {
  const className = `auth-title ${props.textPosition ? props.textPosition : ''}`;

  return (
    <h1 className={className}>{props.name}</h1>
  );
}

export default Title;
